module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch4",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "6",
      "id": "pg_6",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Understand")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "V"
  }, [_vm._v("I’m standing in a palatial courtroom that")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("dates back before the Civil War. The smell of")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("160 years of furniture polish and cleaning")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("solutions weighs heavily in my lungs, and I")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("try in vain not to breathe in through my nose.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Their odor has not disinfected the permanence")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("of all the souls who have stood here before me.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("I feel them.")]), _vm._v(" I hear them warning me, telling")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("me there is a deadly fight before me. At this")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("point, I am just numb.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("It’s taken me sixteen years to get here, and")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("can any battle compare to what has led me")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("here? I’ve reached a point where nothing else")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("matters except my sanity, and most days I")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("cannot find any evidence of that either.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I hear the judge say my name, and I look up")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("into eyes that are curious and searching—")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("and a flicker of hope begins to burn within")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("my chest.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Not like the time he held me against the wall")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("with one arm for fifteen minutes, and I")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("couldn’t wear a bra for three weeks because")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("my insides burned so badly. "), _c('i', [_vm._v("Not that kind of")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("burn.")]), _vm._v(" But I feel an authentic, hopeful flame")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("burning within me. Maybe, just maybe, she will")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("be the one to understand.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecbd406e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 81
// module chunks = 0